
// PRODUCT TABS

document.addEventListener('DOMContentLoaded', function () {
  // Check if the elements exist in the DOM
  const tabsNav = document.querySelector('#tabs-nav');
  if (!tabsNav) return;

  const firstTab = tabsNav.querySelector('li:first-child');
  if (!firstTab) return;

  const tabContents = document.querySelectorAll('.tab-content');
  if (tabContents.length === 0) return;

  // Show the first tab and hide the rest
  firstTab.classList.add('active');
  tabContents.forEach((tab) => {
    tab.style.display = 'none';
  });
  tabContents[0].style.display = 'flex';

  // Click function
  const tabItems = tabsNav.querySelectorAll('li');
  tabItems.forEach((item) => {
    item.addEventListener('mouseenter', function () {
      tabItems.forEach((tabItem) => {
        tabItem.classList.remove('active');
      });
      this.classList.add('active');

      tabContents.forEach((tab) => {
        tab.style.display = 'none';
      });

      const activeTab = this.querySelector('a').getAttribute('href');
      document.querySelector(activeTab).style.display = 'flex';

      event.preventDefault();
    });
  });

});

// PRODUCT COMPARATOR VANILLA JS

function openTab1(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  tabName = document.getElementsByClassName(tabName);
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  for (i = 0; i < tabName.length; i++) {
    tabName[i].style.display = "block";
  }
  
  evt.currentTarget.className += " active";
}


function openTab2(evt, tabName) {
  var i, tabcontent2, tablinks2;
  tabcontent2 = document.getElementsByClassName("tabcontent2");
  tabName = document.getElementsByClassName(tabName);
  
  for (i = 0; i < tabcontent2.length; i++) {
    tabcontent2[i].style.display = "none";
  }
  tablinks2 = document.getElementsByClassName("tablinks2");
  for (i = 0; i < tablinks2.length; i++) {
    tablinks2[i].className = tablinks2[i].className.replace(" active", "");
  }
  
  for (i = 0; i < tabName.length; i++) {
    tabName[i].style.display = "block";
  }
  evt.currentTarget.className += " active";
}

function openTab3(evt, tabName) {
  var i, tabcontent3, tablinks3;
  tabcontent3 = document.getElementsByClassName("tabcontent3");
  tabName = document.getElementsByClassName(tabName);
  for (i = 0; i < tabcontent3.length; i++) {
    tabcontent3[i].style.display = "none";
  }
  tablinks3 = document.getElementsByClassName("tablinks3");
  for (i = 0; i < tablinks3.length; i++) {
    tablinks3[i].className = tablinks3[i].className.replace(" active", "");
  }

  for (i = 0; i < tabName.length; i++) {
    tabName[i].style.display = "block";
  }
  
  evt.currentTarget.className += " active";
}


// END OF PRODUCT COMPARATOR


/* ====== PDP Quantity Inputs ====== */

document.addEventListener('DOMContentLoaded', function () {
  let quantitySelectors = document.querySelectorAll('.quantity__input');
  quantitySelectors.forEach((elm)=> {
    elm.addEventListener('change', function(e) {
      let currentElmVal = event.currentTarget.value;
        quantitySelectors.forEach((nestedElm)=> {
          nestedElm.value = currentElmVal;
        })
    })
  })
});


/* ====== Video Loader Func ====== */

  function isElementInViewport(element) {
    // Get the bounding rectangle of the element
    const rect = element.getBoundingClientRect();

    // Check if the element is within the viewport's boundaries
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  var videoLoader = function(videoLoaderElm) {
    var videos = document.querySelectorAll(videoLoaderElm);
    videos.forEach(function(video) {
      if (isElementInViewport(video)) {
        var sources = video.querySelectorAll('source');
        sources.forEach(function(source) {
          source.src = source.dataset.src;
        });
        video.load();
        console.log('Element is in the viewport. ' + video);

        // Remove the scroll event listener once the element is visible
        window.removeEventListener('scroll', handleScroll);
      }
    });
  };

  function handleScroll() {
    videoLoader('video')
  }

  // Attach the 'handleScroll' function to the 'scroll' event
  window.addEventListener('scroll', handleScroll);
